import "./contact.scss";
import Header from "../header/Header";
import Footer from "../footer/footer";
import { useTranslation } from "react-i18next";
import {
  faPhone,
  faMapMarkerAlt,
  faPaperPlane,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFacebook,
  faTelegram,
  faWhatsapp,
  faViber,
} from "@fortawesome/free-brands-svg-icons";
import { useForm, ValidationError } from "@formspree/react";

const socials = [
  {
    name: "Facebook",
    icon: faFacebook,
    color: "#1877f2",
    bg: "#e7f0fd",
    href: "https://facebook.com",
  },
  {
    name: "Telegram",
    icon: faTelegram,
    color: "#0088cc",
    bg: "#e5f4fb",
    href: "https://t.me/+BFM2rxPtjTs0Njcy",
  },
  {
    name: "Whatsapp",
    icon: faWhatsapp,
    color: "#25d366",
    bg: "#e8f9ee",
    href: "https://api.whatsapp.com/send?phone=+995557396727",
  },
  {
    name: "Viber",
    icon: faViber,
    color: "#59267c",
    bg: "#f0e8f8",
    href: "viber://chat?number=+995557396727",
  },
  {
    name: "+995 557 396 727",
    icon: faPhone,
    color: "#0088cc",
    bg: "#e5f4fb",
    href: "tel:+995557396727",
  },
];

const Contact = () => {
  const { t } = useTranslation();
  const [state, handleSubmit] = useForm("xjgjddeo");

  return (
    <>
      <Header />
      <main className="contact-page">
        <div className="contact-hero">
          <h1 className="contact-title">{t("contact_title")}</h1>
          <address className="contact-address">
            <FontAwesomeIcon icon={faMapMarkerAlt} />
            {t("contact_address")}
          </address>
        </div>

        <div className="contact-content">
          <div className="contact-cards">
            {socials.map((s) => (
              <a
                key={s.name}
                href={s.href}
                target="_blank"
                rel="noreferrer"
                className="contact-card"
              >
                <div
                  className="contact-card-icon"
                  style={{ background: s.bg, color: s.color }}
                >
                  <FontAwesomeIcon icon={s.icon} />
                </div>
                <span className="contact-card-name">{s.name}</span>
                <span className="contact-card-arrow">→</span>
              </a>
            ))}
          </div>

          <div className="contact-form-wrap">
            {state.succeeded ? (
              <div className="form-success">
                <div className="success-icon">✓</div>
                <p>მალე დაგიკავშირდებით.</p>
              </div>
            ) : (
              <form className="contact-form" onSubmit={handleSubmit}>
                <h2 className="form-title">{t("form_title")}</h2>

                <div className="form-group">
                  <label htmlFor="name">{t("form_name")}</label>
                  <input
                    id="name"
                    type="text"
                    name="name"
                    placeholder={t("form_name_placeholder")}
                    required
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="email">{t("form_email")}</label>
                  <input
                    id="email"
                    type="email"
                    name="email"
                    placeholder={t("form_email_placeholder")}
                    required
                  />
                  <ValidationError
                    prefix="Email"
                    field="email"
                    errors={state.errors}
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="message">{t("form_message")}</label>
                  <textarea
                    id="message"
                    name="message"
                    rows="4"
                    placeholder={t("form_message_placeholder")}
                    required
                  />
                  <ValidationError
                    prefix="Message"
                    field="message"
                    errors={state.errors}
                  />
                </div>

                <button
                  type="submit"
                  className="form-submit"
                  disabled={state.submitting}
                >
                  <FontAwesomeIcon icon={faPaperPlane} />
                  {state.submitting ? t("form_sending") : t("form_send")}
                </button>
              </form>
            )}
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
};

export default Contact;
